import moment from "moment"
import { useGetQuery } from "hooks/queries"

export const VALIDATE_INTERVAL_MS = moment.duration(2, "minutes").asMilliseconds()

/**
 * Validates the user's access to a Sigma solution
 */
export default function useValidateUserAccess(accountAlias: string, solutionId: string) {
  const { isError } = useGetQuery({
    url: `/api/${accountAlias}/solutions/sigma/${solutionId}/validate-user-access`,
    key: [accountAlias, solutionId, "validate-user-access"],
    refetchInterval: VALIDATE_INTERVAL_MS,
    refetchIntervalInBackground: true,
    enabled: (query) => query.state.status !== "error",
  })

  return !isError
}
